import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import ImageGallery from './ImageGallery';

const TechnologiesSection: React.FC = () => {
  const { translations } = useLanguage();
  
  // Images for the gallery
  const technologyImages = [
    '/images/SeaDent Modern Technology 1.png',
    '/images/SeaDent Modern Technology 2.jpg',
    '/images/SeaDent Modern Technology 3.png',
    '/images/SeaDent Modern Technology 4.png',
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Image Gallery */}
          <div className="order-1 md:order-2">
            <ImageGallery 
              images={technologyImages} 
              className="h-80 md:h-96 lg:h-[500px] w-full rounded-lg shadow-xl"
              altText={translations.technologies.title}
            />
          </div>
          
          {/* Content */}
          <div className="order-2 md:order-1">
            <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6">{translations.technologies.title}</h2>
            <p className="text-lg text-gray-700 mb-8">{translations.technologies.intro}</p>
          </div>
        </div>
        
        {/* Technology sections */}
        <div className="mt-16 space-y-16">
          {translations.technologies.sections.map((section, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-8 shadow-md">
              <h3 className="text-2xl font-bold text-navy mb-4">{section.title}</h3>
              <p className="text-lg text-gray-700 mb-6">{section.description}</p>
              
              <ul className="space-y-2 text-gray-700">
                {section.benefits.map((benefit, i) => (
                  <li key={i} className="flex items-start">
                    <span className="inline-block mr-3 text-teal-500 flex-shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </span>
                    <span>{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        {/* Conclusion */}
        <div className="mt-16 text-center">
          <p className="text-xl font-medium text-navy">{translations.technologies.conclusion}</p>
        </div>
      </div>
    </section>
  );
};

export default TechnologiesSection; 